<template>
  <div class="flex flex-col space-y-2 animate-pulse">
    <div class="w-full h-[46px] bg-neutral-200 rounded-lg animate-pulse" />
  </div>
</template>

<script>
export default {
  name: 'VetsterSkeletonTimeslot',
};
</script>
